import { RootState } from "../state";

export const selectActivePrometheus = (state: RootState) => {
  const { instances, selectedInstance } = state.environment;
  return instances.find((instance) => instance.id === selectedInstance);
};
